import { SYSFormField } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

export type NewServiceStep2FormFieldKeys =
  | "requesterType"
  | "requesterFirstName"
  | "requesterLastName"
  | "requesterCFirstName"
  | "requesterCLastName"
  | "requesterCPhone"
  | "requesterCEmail"
  | "objectLocationZipCode"
  | "objectLocationCity"
  | "objectLocationStreet"
  | "objectLocationNr"
  | "objectLocationConfirmed"

export let NewServiceStep2FormFieldsDef: {
  [key in NewServiceStep2FormFieldKeys]: SYSFormField
} = {
  requesterType: {
    list: {
      valueField: "CardGroup",
      displayField: "CardGroupDesc",
      mode: "Select",
      displayValueField: false,
    },
    value: "",
    type: "text",
    ui: { labelTranslationKey: "NewServiceRequesterType" },
  },

  requesterFirstName: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceRequesterFirstName",
    },
  },
  requesterLastName: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceRequesterLastName",
    },
  },

  requesterCFirstName: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceRequesterCFirstName",
    },
  },
  requesterCLastName: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceRequesterCLastName",
    },
  },
  requesterCPhone: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceRequesterCPhone",
      inputMode: "tel",
    },
  },
  requesterCEmail: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceRequesterCEmail",
      inputMode: "email",
    },
  },
  objectLocationZipCode: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceObjectLocationZipCode",
    },
    type: "int",
  },
  objectLocationCity: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceObjectLocationCity",
    },
  },

  objectLocationStreet: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceObjectLocationStreet",
    },
  },

  objectLocationNr: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceObjectLocationNr",
    },
  },
  objectLocationConfirmed: {
    value: true,
    ui: {
      labelTranslationKey: "NewServiceObjectLocationConfirmation",
      visible: "false",
    },
    type: "bool",
    schema: {
      nullValidatorToUse: "MandatoryCheck",
      nullValidatorOptions: { validation: { displayType: "OnlyOutline" } },
    },
  },
}
